import {
  Button,
  CircularProgress,
  createStyles,
  FormControlLabel,
  Grid,
  makeStyles,
  Radio,
  RadioGroup,
  TextField,
  Theme,
  WithStyles,
  withStyles,
} from '@freighthub/silhouette-core'
import { action, computed, observable } from 'mobx'
import { observer } from 'mobx-react'
import { ChangeEvent, Component } from 'react'
import { I18N } from 'utils/localisation'

import { IVATResponseJSON } from '../Vat'
import { LegalEntityRegion, TLegalEntity } from './LegalEntitiesModel'

export const testIds = {
  vatValidatorInput: 'vat-validator-input',
}

const jssLegalEntityVatValidator = (theme: Theme) =>
  createStyles({
    radio: {
      width: 24,
      height: 24,
      marginRight: 4,
    },
    label: {
      marginLeft: 2,
      marginBottom: 8,
    },
    radioGroup: {
      dispaly: 'flex',
    },
    businessLocationLabel: {
      flex: 1,
    },
    businuessLocationRadioGroup: {
      flex: 4,
    },
    declerationContainer: {
      marginTop: -8,
    },
    decleration: {
      fontSize: theme.typography.caption.fontSize,
    },
    vatValidationAti: {
      marginBottom: theme.spacing(1),
    },
  })

export interface ILegalEntityVatValidatorProps extends WithStyles<typeof jssLegalEntityVatValidator, false> {
  legalEntity: TLegalEntity
  validateVat?: (vatId: string) => Promise<IVATResponseJSON>
}

export class LeanLegalEntityVatValidator extends Component<ILegalEntityVatValidatorProps> {
  @observable
  // @ts-expect-error TS(2322) FIXME: Type 'null' is not assignable to type 'IVATRespons... Remove this comment to see the full error message
  vatResponse: IVATResponseJSON = null
  @observable
  checkingVat: boolean = false

  onChangeRegion = (e: ChangeEvent<HTMLInputElement>) => {
    this.props.legalEntity.setRegion(e.target.value as LegalEntityRegion)
    this.props.legalEntity.reset()
    // @ts-expect-error TS(2322) FIXME: Type 'null' is not assignable to type 'IVATRespons... Remove this comment to see the full error message
    this.vatResponse = null
  }

  @action
  handleOnVatClick = () => {
    const {
      legalEntity,
      legalEntity: { vatId },
      validateVat,
    } = this.props
    legalEntity.reset()
    if (vatId.value) {
      this.checkingVat = true
      // @ts-expect-error TS(2722) FIXME: Cannot invoke an object which is possibly 'undefin... Remove this comment to see the full error message
      validateVat(vatId.value).then(this.handleVatResponse)
    }
  }

  @action
  handleVatResponse = (res: IVATResponseJSON) => {
    this.vatResponse = res
    this.setVatDetailsToLegalEntity(res)
    this.checkingVat = false
  }

  setVatDetailsToLegalEntity = (vatDetails: IVATResponseJSON): void => {
    const { legalEntity } = this.props
    if (vatDetails.valid && vatDetails.formatValid) {
      legalEntity.setHasValidVat(true)
    }
    if (vatDetails.companyName) {
      legalEntity.setName(vatDetails.companyName)
      legalEntity.name.setDisabled(true)
    }
    if (vatDetails.countryCode) {
      legalEntity.billingAddress.update('countryCode', vatDetails.countryCode)
    }
  }

  @computed
  get vatError(): string {
    if (this.vatResponse === null) {
      return ''
    }
    if (this.vatResponse.formatValid === undefined && !this.vatResponse.valid) {
      return 'vat-validation-error_3rd_party'
    }
    if (!this.vatResponse.formatValid || !this.vatResponse.valid) {
      return 'directory-validation_vat'
    }
    return ''
  }

  handleVatKeyPress = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault()
      this.handleOnVatClick()
    }
  }

  handleOnChangeVat = (e) => {
    this.props.legalEntity.setVatId(e.target.value)
    this.props.legalEntity.setHasValidVat(false)
    this.props.legalEntity.name.setDisabled(false)
  }

  render() {
    const { legalEntity, classes } = this.props
    const { region, vatId } = legalEntity
    const disabled = !this.props.validateVat

    return (
      <Grid alignItems="flex-start" spacing={2} container>
        <Grid xs={12} container alignItems="center">
          <I18N term="vat-validation-business_location" className={classes.businessLocationLabel} />
          <RadioGroup value={region} onChange={this.onChangeRegion} row className={classes.businuessLocationRadioGroup}>
            <FormControlLabel
              disabled={disabled}
              className={classes.label}
              label={<I18N term="vat-validation-european_union" />}
              control={<Radio value={LegalEntityRegion.EU} color="primary" className={classes.radio} />}
            />
            <FormControlLabel
              disabled={disabled}
              className={classes.label}
              label={<I18N term="vat-validation-outside_eu" />}
              control={<Radio value={LegalEntityRegion.NON_EU} color="primary" className={classes.radio} />}
            />
          </RadioGroup>
        </Grid>
        {legalEntity.region === LegalEntityRegion.EU && (
          <VatValidatorInput
            disabled={disabled}
            vatId={vatId.value}
            hasVat={legalEntity.hasVat}
            handleOnVatClick={this.handleOnVatClick}
            handleKeyPress={this.handleVatKeyPress}
            handleOnChange={this.handleOnChangeVat}
            // @ts-expect-error TS(2322) FIXME: Type 'string | false' is not assignable to type 's... Remove this comment to see the full error message
            vatError={
              this.vatError ||
              (legalEntity.triedSubmit && legalEntity.validateVatId().isInvalid && legalEntity.validateVatId().message)
            }
            checkingVat={this.checkingVat}
          />
        )}
        <Grid xs={12} md={11} className={classes.declerationContainer}>
          <I18N term="vat-validation-decleration" className={classes.decleration} />
        </Grid>
        {!legalEntity.hasVat && (
          <Grid xs={12} className={classes.vatValidationAti}>
            <TextField
              disabled={disabled}
              value={legalEntity.taxId?.value}
              label={<I18N term="vat-validation-ati" />}
              fullWidth
              onChange={(e) => legalEntity.setTaxId(e.target.value)}
              error={legalEntity.validateTaxId().isInvalid}
              helperText={legalEntity.validateTaxId().isInvalid && <I18N term={legalEntity.validateTaxId().message} />}
              required
            />
          </Grid>
        )}
      </Grid>
    )
  }
}

export const LegalEntityVatValidator = withStyles(jssLegalEntityVatValidator)(observer(LeanLegalEntityVatValidator))

export interface IVatValidatorInputProps {
  vatId: string
  readonly hasVat: boolean
  handleKeyPress: (e) => void
  handleOnChange: (e) => void
  handleOnVatClick: () => void
  readonly vatError: string
  checkingVat: boolean
  disabled?: boolean
}

const useStylesVatValidatorInput = makeStyles<Theme, IVatValidatorInputProps>((theme) => ({
  verifyButton: {
    color: ({ vatError }) => (vatError ? theme.palette.error.main : theme.palette.primary.main),
  },
}))

export const VatValidatorInput = (props: IVatValidatorInputProps) => {
  const classes = useStylesVatValidatorInput(props)
  const { disabled } = props
  return (
    <Grid container spacing={2} alignItems="center">
      <Grid xs={12} md={8}>
        {disabled && (
          <TextField
            fullWidth
            label={<I18N term="directory-form_vat" />}
            value={props.vatId}
            disabled={disabled}
            data-testid={testIds.vatValidatorInput}
          />
        )}
        {!disabled && (
          <TextField
            fullWidth
            error={!!props.vatError}
            disabled={!props.hasVat}
            label={<I18N term="directory-form_vat" />}
            value={props.vatId}
            onChange={props.handleOnChange}
            onBlur={props.handleOnVatClick}
            onKeyPress={props.handleKeyPress}
            helperText={props.vatError && <I18N term={props.vatError} />}
            InputProps={{
              endAdornment: (
                <Button onClick={props.handleOnVatClick} disabled={!props.hasVat} className={classes.verifyButton}>
                  <I18N term="directory-verify_vat" />
                </Button>
              ),
            }}
            data-testid={testIds.vatValidatorInput}
          />
        )}
      </Grid>
      <Grid xs={2}>{props.checkingVat && <CircularProgress color="primary" size={24} />}</Grid>
    </Grid>
  )
}
